import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import Checkbox from '../../../components/forms/fields/checkbox';
import { getColorLateEarly, getExtendedPaymentManagement, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange, getUserPaymentPermissions } from '../helper';
import ErrorModal from '../../../components/errorModal';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class VisitCancellation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            caseData: null,
            eventData: null,
            payments: [],
            patientData: null,
            form: {
                reasonForCancellation: -1,
                note: '',
                // cancelUnpaidPaymentRequest: false,
                requestRefundToPatient: false,
                requestPaymentCancellation: false
            },
            reasonsForCancellation: []

        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }

    setInitialData = () => {
        const caseId = this.props.caseId;
        if (!caseId) return;

        fetch(API_ENDPOINT + `/api/visit-cancellation/fetch-data/${caseId}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(res => res.json()).then((result) => {
            let setObj = {};
            if (result?.caseData?._id) setObj.caseData = result.caseData;
            if (result?.eventData?._id) setObj.eventData = result.eventData;
            if (result?.payments?.length) setObj.payments = result.payments;
            if (result?.patientData?._id) setObj.patientData = result.patientData;

            this.setState(setObj);
        })


        this.getClinicReasonsForCancellation();


    }




    getClinicReasonsForCancellation = () => {

        const groupData = this.getGroupData();
        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
        if (!EXTENDED_PAYMENT_MANAGEMENT) return;
        const clinicId = this.props.selectedClinic;
        if (!groupData || !clinicId) return;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const cancellationReasons = cancellationAndRefundSettings?.cancellationReasons || [];
        let reasonsForCancellation = [];
        if (cancellationReasons?.length) {
            reasonsForCancellation = cancellationReasons.map((reason, rIdx) => {
                return {
                    ...reason,
                    key: rIdx
                }
            });
        }
        // reasonsForCancellation.push({ key: 'other', en: 'Other', se: 'Other'.translate('se') })

        let setObj = {
            reasonsForCancellation
        };
        this.setState(setObj)
    }

    get = () => {

    }

    componentDidMount() {
        this.get();
        this.setInitialData();


        const userPaymentPermissions = getUserPaymentPermissions(this.props.uData, this.props.selectedGroup, this.props.selectedClinic);
        this.setState({ userPaymentPermissions });
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (refetchData = false, closeUpdateEvent = false) => {
        if (this.props.onClose) {
            this.props.onClose(refetchData, closeUpdateEvent);
        }
    }


    sendRequest = () => {
        const errors = this.checkValidation();

        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const form = this.state.form;
        const caseId = this.props.caseId;
        if (!caseId) return;

        const reasonForCancellation = this.state.reasonsForCancellation?.find(r => String(r.key) === String(form?.reasonForCancellation)) || null;
        const data = {
            note: form?.note && form?.note.trim() ? form?.note.trim() : '',
            reasonForCancellation: reasonForCancellation ? { en: reasonForCancellation.en, se: reasonForCancellation.se } : null,
            // cancelUnpaidPaymentRequest: form?.cancelUnpaidPaymentRequest,
            refundPayments: form?.refundPayments || {},
            refundAmounts: form?.refundAmounts || {},
            cancelPayments: form?.cancelPayments || {},
            messageToPatient: form?.messageToPatient || '',
            // requestRefundToPatient: form?.requestRefundToPatient,
            // requestPaymentCancellation: form?.requestPaymentCancellation
        }

        this.setState({ loadingCancelVisit: true }, () => {
            fetch(API_ENDPOINT + `/api/visit-cancellation/cancel-visit/${caseId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingCancelVisit: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose(true, true);
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const groupData = this.getGroupData();
        const caseData = this.state.caseData;
        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
        const form = this.state.form;
        let errors = {};

        const reasonForCancellation = this.state.reasonsForCancellation?.find(r => String(r.key) === String(form?.reasonForCancellation)) || null;
        const note = form?.note && form?.note.trim() ? form?.note.trim() : '';
        if (!reasonForCancellation && this.state.reasonsForCancellation?.length) errors.reasonForCancellation = 'Reason for cancellation is required'.translate(this.props.lang);
        const isReasonForCancellationOther = reasonForCancellation && (reasonForCancellation?.en?.trim().toLowerCase() === 'other' || reasonForCancellation?.se?.trim().toLowerCase() === 'other');
        if (((!reasonForCancellation && !errors.reasonForCancellation) || isReasonForCancellationOther) && !note) errors.note = 'Note is required'.translate(this.props.lang);
        // if (!EXTENDED_PAYMENT_MANAGEMENT && errors.note) {
        //     delete errors.note;
        // }

        if (EXTENDED_PAYMENT_MANAGEMENT && form?.refundPayments) {
            const checkedPaymentIds = Object.keys(form.refundPayments).filter(id => form.refundPayments[id]);

            if (checkedPaymentIds.length) {
                checkedPaymentIds.forEach(paymentId => {
                    const payment = caseData?.paymentData?.find(p => p.paymentId === paymentId);
                    let maxAmount = payment?.amount?.value ? Number(payment.amount.value) : 0;
                    if (payment?.amount?.refundAmount) {
                        const alreadyRefundedAmount = payment.amount.refundAmount ? Number(payment.amount.refundAmount) : 0;
                        maxAmount -= alreadyRefundedAmount;
                    }
                    const refundAmount = form?.refundAmounts?.[paymentId] !== undefined ? Number(form.refundAmounts[paymentId]) : 0;
                    if (!refundAmount || refundAmount <= 0) {
                        if (!errors.refundAmounts) errors.refundAmounts = {};
                        errors.refundAmounts[paymentId] = 'Refund amount is required'.translate(this.props.lang);
                    } else if (refundAmount > maxAmount) {
                        if (!errors.refundAmounts) errors.refundAmounts = {};
                        errors.refundAmounts[paymentId] = `${'Refund cannot exceed'.translate(this.props.lang)} ${maxAmount} ${this.getCurrency()}`;
                    }
                });
            }
        }


        return Object.keys(errors).length ? errors : null;
    }
    getBasicPaymentInfo = (data) => {
        const { caseData, eventData, payments, patientData } = this.state;
        const questionaryName = caseData?.questionaryName ?? '';
        const caseNumber = caseData?.patient?.referralNumber ?? '';
        const patientName = patientData?.name ?? '';
        const patientSSN = patientData?.socialSecurityNumber ?? '';
        const scheduledTs = caseData?.patientReservedTimestamp ?? eventData?.startTime ?? null;
        const scheduledDateTime = scheduledTs ? this.props.getStringDateTs(scheduledTs, `${this.props.dateFormat} HH:mm`) : '';

        let response = {
            questionaryName: questionaryName,
            caseNumber: caseNumber,
            patientName: patientName,
            patientSSN: patientSSN,
            scheduledDateTime: scheduledDateTime
        };

        return response;
    }
    getUserPermissions = () => {
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;
        if (!clinicId || !groupId) return {};

        const permissions = this.props.uData?.permissions || {};
        const userGroupPermissions = this.props.uData?.groupPermissionsUser?.[groupId]?.[clinicId] || [];

        let response = {};
        for (var key in permissions) {
            response[key] = userGroupPermissions.includes(permissions[key]) ? true : false;
        }
        return response;
    }
    getCancellationPeriod = () => {
        const groupData = this.getGroupData();
        const clinicId = this.props.selectedClinic;
        if (!groupData || !clinicId) return null;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;

        const lateCancellationPeriod = cancellationAndRefundSettings?.lateCancellationPeriod || 0;
        const { caseData, eventData, payments, patientData } = this.state;
        const scheduledTs = caseData?.patientReservedTimestamp ?? eventData?.startTime ?? null;
        if (!scheduledTs) return null;

        const tsNow = Math.floor(new Date().getTime() / 1000);

        const diffInHours = (scheduledTs - tsNow) / 3600;
        const cancellationPeriod = diffInHours > lateCancellationPeriod ? 'early' : 'late';
        return cancellationPeriod;
    }

    checkIfPaymentMethodIsStripe = () => {
        const { caseData } = this.state;
        const isStripePaymentMethod = caseData?.paymentData?.filter(p => p?.currentStatus?.paymentMethod?.key === 'stripe')?.length > 0 ? true : false;
        return isStripePaymentMethod;
    }

    generateNoteMessage = () => {
        const { caseData, eventData } = this.state;
        const isStripePaymentMethod = this.checkIfPaymentMethodIsStripe();
        const groupData = this.getGroupData();
        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
        const clinicId = this.props.selectedClinic;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const clinicActions = cancellationAndRefundSettings?.clinicActions || null;
        const { allowClinicianToRefundPayment, allowClinicianToCancelAnUnpaidPayment } = clinicActions ?? {};

        let message = <></>;

        const statuses = this.getPaymentStatuses();
        const isRefundAmountAvailable = this.checkIsRefundAmountAvailable();
        const userPermissions = this.getUserPermissions();

        const includedPaid = statuses?.includes('PAID') && isRefundAmountAvailable ? true : false;
        const includedUnpaid = statuses?.includes('UNPAID');
        const includedPartiallyRefunded = statuses?.includes('PARTIALLY_REFUNDED');

        const scheduledTs = caseData?.patientReservedTimestamp ?? eventData?.startTime ?? null;
        if (!scheduledTs) return null;
        const tsNow = Math.floor(new Date().getTime() / 1000);
        const diffInHours = (scheduledTs - tsNow) / 3600;
        const lateCancellationPeriod = cancellationAndRefundSettings?.lateCancellationPeriod || 0;
        const cancellationPeriod = diffInHours > lateCancellationPeriod ? 'early' : 'late';

        const userCondition = userPermissions?.admin || (userPermissions?.doctor && allowClinicianToRefundPayment) ? true : false;
        // const userCanCancelUnpaid = userPermissions?.admin || (userPermissions?.doctor && allowClinicianToCancelAnUnpaidPayment) ? true : false;

        if (isStripePaymentMethod && EXTENDED_PAYMENT_MANAGEMENT && userCondition) {
            if (includedPaid || includedPartiallyRefunded) {
                message = <><span><b>{'Note:'.translate(this.props.lang)}</b></span> {`Stripe payments are refunded automatically from Curoflow. For other methods, payment will be marked as "refunded", but you still need to issue the refund manually.`.translate(this.props.lang)}</>;

            }
        }


        if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && includedUnpaid && !includedPaid && cancellationPeriod === 'late') {
            message = <><span><b>{'Note:'.translate(this.props.lang)}</b></span> {`You do not have permission to perform refunds or cancellations. Submitting this will only send a request to your clinic admin, who will review and complete the action.`.translate(this.props.lang)}</>;
        }
        if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && !includedUnpaid && includedPaid && cancellationPeriod === 'late') {
            message = <><span><b>{'Note:'.translate(this.props.lang)}</b></span> {`You do not have permission to perform refunds or cancellations. Submitting this will only send a request to your clinic admin, who will review and complete the action`.translate(this.props.lang)}</>;
        }
        if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && includedUnpaid && includedPaid && cancellationPeriod === 'late') {
            message = <><span><b>{'Note:'.translate(this.props.lang)}</b></span> {`You do not have permission to perform refunds or cancellations. Submitting this will only send a request to your clinic admin, who will review and complete the action`.translate(this.props.lang)}</>;
        }

        // if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && !includedUnpaid && includedPaid && cancellationPeriod === 'early') {
        //     message = <><span><b>{'Note:'.translate(this.props.lang)}</b></span> {`You do not have permission to perform refunds. Submitting this will only send a request to your clinic admin, who will review and complete the action`.translate(this.props.lang)}</>;
        // }
        // if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && includedUnpaid && includedPaid && cancellationPeriod === 'early') {
        //     message = <><span><b>{'Note:'.translate(this.props.lang)}</b></span> {`You do not have permission to perform refunds. Submitting this will only send a request to your clinic admin, who will review and complete the action`.translate(this.props.lang)}</>;
        // }

        return message;
    }
    checkIfUserHasPermissionToRefund = () => {
        const userPermissions = this.getUserPermissions();
        const groupData = this.getGroupData();
        const clinicId = this.props.selectedClinic;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const clinicActions = cancellationAndRefundSettings?.clinicActions || null;
        const { allowClinicianToRefundPayment } = clinicActions ?? {};
        const canRefund = userPermissions?.admin || (userPermissions?.doctor && allowClinicianToRefundPayment) ? true : false;
        return canRefund;
    }

    checkIfUserHasPermissionToCancelUnpaidPayment = () => {
        const userPermissions = this.getUserPermissions();
        const groupData = this.getGroupData();
        const clinicId = this.props.selectedClinic;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const clinicActions = cancellationAndRefundSettings?.clinicActions || null;
        const { allowClinicianToCancelAnUnpaidPayment } = clinicActions ?? {};
        const canCancelUnpaid = userPermissions?.admin || (userPermissions?.doctor && allowClinicianToCancelAnUnpaidPayment) ? true : false;
        return canCancelUnpaid;
    }

    getRefundAndCancellationMessage = () => {
        const groupData = this.getGroupData();
        const clinicId = this.props.selectedClinic;
        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
        if (!groupData || !clinicId) return null;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const clinicActions = cancellationAndRefundSettings?.clinicActions || null;
        const {
            // markEarlyCancellationAsRefundRequest,
            automaticallyRefundEarlyCancellations, // doesn't exist anymore anywhere in the codebase, but left here just in case, since it was used in the logic for the message
            // allowLateCancellationRefund,
            allowClinicianToCancelAnUnpaidPayment,
            allowClinicianToRefundPayment
        } = clinicActions ?? {};

        const lateCancellationPeriod = cancellationAndRefundSettings?.lateCancellationPeriod || 0;

        const { caseData, eventData, payments, patientData } = this.state;
        const scheduledTs = caseData?.patientReservedTimestamp ?? eventData?.startTime ?? null;
        if (!scheduledTs) return null;

        // const isStripePaymentMethod = this.checkIfPaymentMethodIsStripe();

        const tsNow = Math.floor(new Date().getTime() / 1000);

        const diffInHours = (scheduledTs - tsNow) / 3600;
        const cancellationPeriod = diffInHours > lateCancellationPeriod ? 'early' : 'late';

        const statuses = this.getPaymentStatuses();

        const userPermissions = this.getUserPermissions();

        const userCondition = userPermissions?.admin || (userPermissions?.doctor && allowClinicianToRefundPayment) ? true : false;
        // const userCanCancelUnpaid = userPermissions?.admin || (userPermissions?.doctor && allowClinicianToCancelAnUnpaidPayment) ? true : false;

        let message, firstPartMessage, secondPartMessage = '';
        const isRefundAmountAvailable = this.checkIsRefundAmountAvailable();

        const includedPaid = statuses?.includes('PAID') && isRefundAmountAvailable ? true : false;
        const includedUnpaid = statuses?.includes('UNPAID');
        const includedPartiallyRefunded = statuses?.includes('PARTIALLY_REFUNDED');
        const includedRefunded = statuses?.includes('REFUNDED');


        const { colorLateEarly, earlyColor, lateColor } = getColorLateEarly();

        if (cancellationPeriod === 'early') {

            // if (colorLateEarly) {
            //     firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}.</>;
            // } else {
            //     firstPartMessage = `This is an early cancellation.`.translate(this.props.lang);
            // }
            if ((includedPaid || includedPartiallyRefunded) && automaticallyRefundEarlyCancellations && userCondition) { // because of automaticallyRefundEarlyCancellations isn't used anywhere in the codebase anymore this will never be true, but left here just in case, since it was used in the logic for the message
                if (!EXTENDED_PAYMENT_MANAGEMENT) {
                    if (colorLateEarly) {
                        firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)} {'with a paid payment'.translate(this.props.lang)}.</>;
                    } else {
                        firstPartMessage = `This is an early cancellation with a paid payment.`.translate(this.props.lang);
                    }
                }
                // else if (!includedUnpaid) {
                //     secondPartMessage += ` ${'Refund to patient will be done automatically'.translate(this.props.lang)}`;
                // } else {
                //     secondPartMessage += ` ${'Refund to patient will be done automatically for paid or partially refunded payments'.translate(this.props.lang)}`;
                // }
            } else if ((includedPaid || includedPartiallyRefunded) && (!automaticallyRefundEarlyCancellations || !userCondition) /*&& markEarlyCancellationAsRefundRequest*/) {
                if (!EXTENDED_PAYMENT_MANAGEMENT) {
                    if (colorLateEarly) {
                        firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)} {'with a paid payment'.translate(this.props.lang)}.</>;
                    } else {
                        firstPartMessage = `This is an early cancellation with a paid payment.`.translate(this.props.lang);
                    }
                }
                // else if (!includedUnpaid) {
                //     secondPartMessage += ` ${'Payment will be marked as "Refund requested"'.translate(this.props.lang)}`;
                // } else {
                //     secondPartMessage += ` ${'Payment will be marked as "Refund requested" for paid or partially refunded payments'.translate(this.props.lang)}`;
                // }
            }
            if (EXTENDED_PAYMENT_MANAGEMENT && userCondition && includedPaid) {
                firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {`Select payments to refund below, or it will be marked as "refund requested"`.translate(this.props.lang)}.</>;
            } else if (EXTENDED_PAYMENT_MANAGEMENT && userCondition && includedUnpaid) {
                firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Unpaid payments are automatically cancelled'.translate(this.props.lang)}.</>;
            }

            if (EXTENDED_PAYMENT_MANAGEMENT && userCondition && includedPaid && includedUnpaid) {
                firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Unpaid payments are automatically cancelled'.translate(this.props.lang)}. {`Select payments to refund below, or it will be marked as "refund requested"`.translate(this.props.lang)}.</>;
            }

            if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT
                // && includedUnpaid && !includedPaid
            ) {
                firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Unpaid payments are automatically cancelled, and a refund request will be made for paid payments'.translate(this.props.lang)}.</>;
            }
            // if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && !includedUnpaid && includedPaid) {
            //     firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Select any payments you want to request a refund for'.translate(this.props.lang)}.</>;
            // }
            // if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && includedUnpaid && includedPaid) {
            //     firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Select any payments you want to request a refund for'.translate(this.props.lang)}.</>;
            // }

            if (includedUnpaid) {
                if (!EXTENDED_PAYMENT_MANAGEMENT) {
                    secondPartMessage += ` ${'The payment will be cancelled.'.translate(this.props.lang)}`;
                }
                // else if (includedPaid || includedPartiallyRefunded) {
                //     secondPartMessage += ` ${'There is at least one unpaid payment – choose if payment should be cancelled.'.translate(this.props.lang)}`;
                // } else {
                //     secondPartMessage += ` ${'Payment is Unpaid - choose if payment should be cancelled.'.translate(this.props.lang)}`;
                // }
            }
            // if (EXTENDED_PAYMENT_MANAGEMENT && userCondition && includedUnpaid && !includedPaid) {
            //     firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: earlyColor }}>{'early'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {`Unpaid payments are automatically cancelled`.translate(this.props.lang)}. </>;
            // }
        } else if (cancellationPeriod === 'late') {
            // if (colorLateEarly) {
            //     firstPartMessage = <>{'This is a'.translate(this.props.lang)} <span style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}.</>;
            // } else {
            //     firstPartMessage = `This is a late cancellation.`.translate(this.props.lang);
            // }
            if ((includedPaid || includedPartiallyRefunded)) {
                if (!EXTENDED_PAYMENT_MANAGEMENT) {
                    if (colorLateEarly) {
                        firstPartMessage = <>{'This is a'.translate(this.props.lang)} <span style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)} {'with a paid payment'.translate(this.props.lang)}.</>;
                    } else {
                        firstPartMessage = `This is a late cancellation with a paid payment.`.translate(this.props.lang);
                    }
                }
                // else if (!includedUnpaid) {
                //     secondPartMessage += ` ${'Refund of payment can only be done by admin later.'.translate(this.props.lang)}`;
                // } else {
                //     secondPartMessage += ` ${'Refund of payment can only be done by admin later for paid or partially refunded payments.'.translate(this.props.lang)}`;
                // }
            }
            if (EXTENDED_PAYMENT_MANAGEMENT && userCondition && includedPaid) {
                firstPartMessage = <>{'This is a'.translate(this.props.lang)} <span style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Select any payments you want to refund below'.translate(this.props.lang)}.</>;
            } else if (EXTENDED_PAYMENT_MANAGEMENT && userCondition && includedUnpaid) {
                firstPartMessage = <>{'This is a'.translate(this.props.lang)} <span style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Select any payments you want to cancel below'.translate(this.props.lang)}.</>;
            }
            if (EXTENDED_PAYMENT_MANAGEMENT && userCondition && includedPaid && includedUnpaid) {
                firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Select any payments you want to refund or request payment cancellation below'.translate(this.props.lang)}.</>;
            }

            if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && includedUnpaid && !includedPaid) {
                firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Select any payments you want to request a refund or cancellation for'.translate(this.props.lang)}.</>;
            }
            if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && !includedUnpaid && includedPaid) {
                firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Select any payments you want to request a refund or cancellation for'.translate(this.props.lang)}.</>;
            }
            if (!userCondition && EXTENDED_PAYMENT_MANAGEMENT && includedUnpaid && includedPaid) {
                firstPartMessage = <>{'This is an'.translate(this.props.lang)} <span style={{ color: lateColor }}>{'late'.translate(this.props.lang)}</span> {'cancellation'.translate(this.props.lang)}. {'Select any payments you want to request a refund or cancellation for'.translate(this.props.lang)}.</>;
            }

            if (includedUnpaid) {
                if (!EXTENDED_PAYMENT_MANAGEMENT) {
                    secondPartMessage += ` ${'The payment request will remain.'.translate(this.props.lang)}`;
                }
                // else if (includedPaid || includedPartiallyRefunded) {
                //     secondPartMessage += ` ${'There is at least one unpaid payment – select if patient should still pay the unpaid payment.'.translate(this.props.lang)}`;
                // } else {
                //     secondPartMessage += ` ${'Select if patient should still pay the unpaid payment.'.translate(this.props.lang)}`;
                // }
            }
        }
        message = <>{firstPartMessage}{secondPartMessage}</>;
        return message;
    }
    getPaymentStatuses = () => {
        const payments = this.state.payments || [];
        let statuses = [];
        for (let i = 0; i < payments.length; i++) {
            let payment = payments[i];
            const isPaymentCancelled = payment?.labels?.find(l => l.label?.key === 'payment_cancelled') ? true : false;
            if (isPaymentCancelled) continue;
            let status = payment?.currentStatus?.status?.key;
            if (status && !statuses.includes(status))
                statuses.push(status);
        }
        if (!statuses.length) return null;

        return statuses;
    }
    checkIsRefundAmountAvailable = () => {
        const payments = this.state.payments || [];
        let totalRefundableAmountAvailable = 0;
        for (let i = 0; i < payments.length; i++) {
            let payment = payments[i];
            const isPaymentCancelled = payment?.labels?.find(l => l.label?.key === 'payment_cancelled') ? true : false;
            if (isPaymentCancelled) continue;
            let status = payment?.currentStatus?.status?.key;
            if (['PAID', 'PARTIALLY_REFUNDED'].includes(status)) {
                const amount = payment?.amount?.value ? Number(payment?.amount?.value) : 0;
                totalRefundableAmountAvailable += amount;
            }
        }
        return totalRefundableAmountAvailable > 0 ? true : false;
    }
    render() {
        const isOpen = this.props.isOpen;
        const { caseData, eventData, payments, patientData } = this.state;

        if (!caseData) {
            return null;
        }

        const cancellationPeriod = this.getCancellationPeriod();

        // const userPaymentPermissions = this.state.userPaymentPermissions || {};

        const currency = this.getCurrency();
        const errors = this.state.errors ?? {};

        const basicPaymentInfo = this.getBasicPaymentInfo();
        const refundAndCancellationMessage = this.getRefundAndCancellationMessage();

        const statuses = this.getPaymentStatuses();

        const groupData = this.getGroupData();

        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);

        const isRefundAmountAvailable = this.checkIsRefundAmountAvailable();

        // const showCancelUnpaidPaymentRequestCheckBox = statuses?.includes('UNPAID') && userPaymentPermissions?.cancelPayments ? true : false;
        const showRequestRefundToPatient = EXTENDED_PAYMENT_MANAGEMENT && (statuses?.includes('PAID') || statuses?.includes('PARTIALLY_REFUNDED')) && isRefundAmountAvailable && cancellationPeriod === 'late' ? true : false;
        const showRequestPaymentCancellation = EXTENDED_PAYMENT_MANAGEMENT && statuses?.includes('UNPAID') && cancellationPeriod === 'late' ? true : false;

        const showMessageToPatient = EXTENDED_PAYMENT_MANAGEMENT && (statuses?.includes('PAID') || statuses?.includes('PARTIALLY_REFUNDED')) && isRefundAmountAvailable ? true : false;
        return (
            <>
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Cancel visit'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody className='create-payment-modal-body'>
                        <Row>
                            <Col lg='6'>
                                <div className='basic-payment-info-wrap'>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo?.questionaryName}
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        <span>{'Case ID'.translate(this.props.lang)}:</span> {basicPaymentInfo?.caseNumber}
                                    </div>
                                </div>
                            </Col>

                            <Col lg='6'>
                                <div className='basic-payment-info-wrap'>
                                    <div className='basic-payment-info-item'>
                                        <span>{'Scheduled'.translate(this.props.lang)}:</span> {basicPaymentInfo?.scheduledDateTime}
                                    </div>
                                </div>
                            </Col>

                            {
                                refundAndCancellationMessage ?
                                    <Col lg='12'>
                                        <div className='basic-payment-info-wrap'>
                                            <div className='basic-payment-info-item'>
                                                {refundAndCancellationMessage}
                                            </div>
                                        </div>
                                    </Col>
                                    :
                                    null
                            }
                            {
                                EXTENDED_PAYMENT_MANAGEMENT ?
                                    <Col lg='12'>
                                        <div className='basic-payment-info-wrap'>
                                            <div className='basic-payment-info-note-item'>
                                                {this.generateNoteMessage()}
                                            </div>
                                        </div>
                                    </Col>
                                    :
                                    null
                            }
                            {
                                // showRequestRefundToPatient ?
                                //     <Col lg='12'>
                                //         <FormGroup>
                                //             <Checkbox
                                //                 checked={this.state.form?.requestRefundToPatient || false}
                                //                 onChange={(e) => {
                                //                     let form = this.state.form;
                                //                     form.requestRefundToPatient = !form.requestRefundToPatient;
                                //                     this.setState({ form });
                                //                 }}
                                //                 label={'Request refund to patient'.translate(this.props.lang)}
                                //             />
                                //         </FormGroup>
                                //     </Col> : null
                            }
                            {
                                // showRequestPaymentCancellation ?
                                //     <Col lg='12'>
                                //         <FormGroup>
                                //             <Checkbox
                                //                 checked={this.state.form?.requestPaymentCancellation || false}
                                //                 onChange={(e) => {
                                //                     let form = this.state.form;
                                //                     form.requestPaymentCancellation = !form.requestPaymentCancellation;
                                //                     this.setState({ form });
                                //                 }}
                                //                 label={'Request payment cancellation'.translate(this.props.lang)}
                                //             />
                                //         </FormGroup>
                                //     </Col> : null
                            }
                            {/* {
                                showCancelUnpaidPaymentRequestCheckBox ?
                                    <Col lg='12'>
                                        <FormGroup>
                                            <Checkbox
                                                checked={this.state.form?.cancelUnpaidPaymentRequest || false}
                                                onChange={(e) => {
                                                    let form = this.state.form;
                                                    form.cancelUnpaidPaymentRequest = !form.cancelUnpaidPaymentRequest;
                                                    this.setState({ form });
                                                }}
                                                label={'Cancel unpaid payment request'.translate(this.props.lang)}
                                            />
                                        </FormGroup>
                                    </Col> : null
                            } */}

                            {
                                EXTENDED_PAYMENT_MANAGEMENT
                                    // && (this.checkIfUserHasPermissionToRefund() || this.checkIfUserHasPermissionToCancelUnpaidPayment()) 
                                    ?
                                    <Col lg='12'>
                                        <Row>
                                            <Col lg='8'>
                                                <FormGroup style={{ marginBottom: 'unset' }}>
                                                    <Label>{'Payments'.translate(this.props.lang)}</Label>
                                                </FormGroup>
                                            </Col>
                                            {
                                                showMessageToPatient && this.checkIfUserHasPermissionToRefund() ?
                                                    <Col lg='4' >
                                                        <FormGroup style={{ marginBottom: 'unset' }} >
                                                            <Label>{'Refund amount'.translate(this.props.lang)}:</Label>
                                                        </FormGroup>
                                                    </Col>
                                                    :
                                                    null
                                            }

                                        </Row>
                                        {
                                            caseData?.paymentData?.length && EXTENDED_PAYMENT_MANAGEMENT ?
                                                caseData.paymentData.map((payment) => {
                                                    const amount = payment?.amount?.value ? Number(payment?.amount?.value) : 0;
                                                    const isPaymentCancelled = payment?.labels?.find(l => l.label?.key === 'payment_cancelled') ? true : false;
                                                    if (isPaymentCancelled) return null;
                                                    const status = payment?.currentStatus?.status?.key;
                                                    const paymentMethod = payment?.currentStatus?.paymentMethod?.key;
                                                    const isRefunded = status === 'REFUNDED';
                                                    const isPartiallyRefunded = status === 'PARTIALLY_REFUNDED';
                                                    const isPaid = status === 'PAID';
                                                    const canRefund = (isPaid || isPartiallyRefunded) && !isRefunded ? true : false;
                                                    if (canRefund && (isPaid || isPartiallyRefunded)) {
                                                        this.state.form.refundAmounts = this.state.form.refundAmounts || {};
                                                        if (!(payment.paymentId in this.state.form.refundAmounts)) {
                                                            this.state.form.refundAmounts[payment.paymentId] = amount;
                                                        }
                                                    }

                                                    if ((isPaid || isPartiallyRefunded))
                                                        return (
                                                            <Row>
                                                                <Col lg='8'>
                                                                    <FormGroup style={{ backgroundColor: '#f5f5f5', borderRadius: '6px', padding: 10, marginBottom: 'unset' }}>
                                                                        {
                                                                            amount > 0 && ((this.checkIfUserHasPermissionToRefund() && cancellationPeriod === 'early') || cancellationPeriod === 'late') ?
                                                                                <Checkbox
                                                                                    fullWidth={true}
                                                                                    checked={this.state.form?.refundPayments?.[payment.paymentId] || false}
                                                                                    onChange={(e) => {
                                                                                        let form = this.state.form;
                                                                                        if (!form.refundPayments) form.refundPayments = {};
                                                                                        form.refundPayments[payment.paymentId] = !form.refundPayments[payment.paymentId];
                                                                                        let setObj = { form };
                                                                                        // if (this.state.errors?.refundPayments) {
                                                                                        //     let errors = this.state.errors;
                                                                                        //     delete errors.refundPayments;
                                                                                        //     setObj.errors = errors;
                                                                                        // }
                                                                                        this.setState(setObj);
                                                                                    }}
                                                                                    label={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                                            <span>{amount}</span>
                                                                                            <span>{currency}</span>
                                                                                            <span>{paymentMethod}</span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <span style={{ backgroundColor: '#28a745', color: 'white', padding: '4px 12px', borderRadius: 15 }}>{'Paid'.translate(this.props.lang)}</span>
                                                                                        </div>
                                                                                    </div>}
                                                                                />
                                                                                :
                                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                                        <span>{amount}</span>
                                                                                        <span>{currency}</span>
                                                                                        <span>{paymentMethod}</span>
                                                                                    </div>
                                                                                    <div>
                                                                                        <span style={{ backgroundColor: '#28a745', color: 'white', padding: '4px 12px', borderRadius: 15 }}>{'Paid'.translate(this.props.lang)}</span>
                                                                                    </div>
                                                                                </div>
                                                                        }
                                                                    </FormGroup>
                                                                </Col>

                                                                {amount > 0 && this.checkIfUserHasPermissionToRefund() && <Col lg='4' >
                                                                    <FormGroup >
                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                                                                            <Input
                                                                                type='number'
                                                                                value={this.state.form?.refundAmounts?.[payment.paymentId] ?? ''}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;

                                                                                    const newForm = {
                                                                                        ...this.state.form,
                                                                                        refundAmounts: { ...(this.state.form?.refundAmounts || {}) }
                                                                                    };
                                                                                    let finalValue = value;
                                                                                    if (value !== '' && Number(value) > amount) {
                                                                                        finalValue = amount;
                                                                                    }

                                                                                    if (value !== '' && Number(value) < 0) {
                                                                                        finalValue = 0;
                                                                                    }

                                                                                    newForm.refundAmounts[payment.paymentId] = finalValue;

                                                                                    let newErrors = this.state.errors;
                                                                                    if (newErrors?.refundAmounts?.[payment.paymentId]) {
                                                                                        newErrors = { ...newErrors };
                                                                                        delete newErrors.refundAmounts[payment.paymentId];
                                                                                    }

                                                                                    this.setState({ form: newForm, errors: newErrors });
                                                                                }}
                                                                            />
                                                                            <div>{currency}</div>
                                                                        </div>

                                                                    </FormGroup>
                                                                </Col>}
                                                                <Col lg='12'>
                                                                    <FormGroup className={errors.refundAmounts?.[payment.paymentId] ? 'fg-has-error' : ''}>
                                                                        {errors.refundAmounts?.[payment.paymentId] ? <div className='error-feedback'>{errors.refundAmounts[payment.paymentId]}</div> : null}
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>

                                                        )
                                                    if (!isPaid && !canRefund) {
                                                        return (
                                                            <Row>
                                                                {
                                                                    cancellationPeriod === 'late' ?
                                                                        <Col lg='8'>
                                                                            <FormGroup style={{ backgroundColor: '#f5f5f5', borderRadius: '6px', padding: 10 }}>
                                                                                {
                                                                                    // this.checkIfUserHasPermissionToRefund() ?
                                                                                    <Checkbox
                                                                                        fullWidth={true}
                                                                                        checked={this.state.form?.cancelPayments?.[payment.paymentId] || false}
                                                                                        onChange={(e) => {
                                                                                            let form = this.state.form;
                                                                                            if (!form.cancelPayments) form.cancelPayments = {};
                                                                                            form.cancelPayments[payment.paymentId] = !form.cancelPayments[payment.paymentId];
                                                                                            let setObj = { form };
                                                                                            if (this.state.errors?.cancelPayments) {
                                                                                                let errors = this.state.errors;
                                                                                                delete errors.cancelPayments;
                                                                                                setObj.errors = errors;
                                                                                            }
                                                                                            this.setState(setObj);
                                                                                        }}
                                                                                        label={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                                                <span>{amount}</span>
                                                                                                <span>{currency}</span>
                                                                                            </div>
                                                                                            <div>
                                                                                                <span style={{ backgroundColor: '#dc3545', color: 'white', padding: '4px 12px', borderRadius: 15 }}>{'Unpaid'.translate(this.props.lang)}</span>
                                                                                            </div>
                                                                                        </div>}
                                                                                    />
                                                                                    // :
                                                                                    // <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                                    //     <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                                    //         <span>{amount}</span>
                                                                                    //         <span>{currency}</span>
                                                                                    //     </div>
                                                                                    //     <div>
                                                                                    //         <span style={{ backgroundColor: '#dc3545', color: 'white', padding: '4px 12px', borderRadius: 15 }}>{'Unpaid'.translate(this.props.lang)}</span>
                                                                                    //     </div>
                                                                                    // </div>
                                                                                }
                                                                            </FormGroup>
                                                                        </Col>
                                                                        :
                                                                        <Col lg='8'>
                                                                            <FormGroup style={{ backgroundColor: '#f5f5f5', borderRadius: '6px', padding: 10 }}>
                                                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                                                        <span>{amount}</span>
                                                                                        <span>{currency}</span>
                                                                                    </div>
                                                                                    <div>
                                                                                        <span style={{ backgroundColor: '#dc3545', color: 'white', padding: '4px 12px', borderRadius: 15 }}>{'Unpaid'.translate(this.props.lang)}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </FormGroup>
                                                                        </Col>
                                                                }

                                                            </Row>
                                                        )
                                                    }
                                                })
                                                :
                                                null
                                        }
                                    </Col>
                                    :
                                    null
                            }

                            {
                                this.state.reasonsForCancellation?.length ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.reasonForCancellation ? 'fg-has-error' : ''}>
                                            <Label>{'Reason for cancellation'.translate(this.props.lang)}</Label>
                                            <Input
                                                type='select'
                                                value={this.state.form?.reasonForCancellation || -1}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    if (!value) value = -1;
                                                    let form = this.state.form;
                                                    form.reasonForCancellation = value;
                                                    let setObj = { form };
                                                    if (this.state.errors?.reasonForCancellation || this.state.errors?.note) {
                                                        let errors = this.state.errors;
                                                        delete errors.reasonForCancellation;
                                                        delete errors.note;
                                                        setObj.errors = errors;
                                                    }
                                                    this.setState(setObj);
                                                }}
                                            >
                                                <option value={-1}>{'Select reason'.translate(this.props.lang)}</option>
                                                {
                                                    this.state.reasonsForCancellation.map((reason, rIdx) => {
                                                        return <option value={reason.key}>{reason?.[this.props.lang]}</option>
                                                    })
                                                }

                                            </Input>
                                            {errors.reasonForCancellation ? <div className='error-feedback'>{errors.reasonForCancellation}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }
                            {
                                showMessageToPatient ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.messageToPatient ? 'fg-has-error' : ''}>
                                            <Label>{'Message to patient'.translate(this.props.lang)}</Label>
                                            <Input
                                                type='textarea'
                                                value={this.state.form?.messageToPatient || ''}
                                                style={{ height: 100 }}
                                                onChange={(e) => {
                                                    let form = this.state.form;
                                                    form.messageToPatient = e.target.value;
                                                    let setObj = { form };
                                                    if (this.state.errors?.messageToPatient) {
                                                        let errors = this.state.errors;
                                                        delete errors.messageToPatient;
                                                        setObj.errors = errors;
                                                    }
                                                    this.setState(setObj);
                                                }}
                                            />
                                            {errors.messageToPatient ? <div className='error-feedback'>{errors.messageToPatient}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }

                            <Col lg='12'>
                                <FormGroup className={errors.note ? 'fg-has-error' : ''}>
                                    <Label>{'Note'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='textarea'
                                        value={this.state.form?.note || ''}
                                        style={{ height: 100 }}
                                        onChange={(e) => {
                                            let form = this.state.form;
                                            form.note = e.target.value;
                                            let setObj = { form };
                                            if (this.state.errors?.note) {
                                                let errors = this.state.errors;
                                                delete errors.note;
                                                setObj.errors = errors;
                                            }
                                            this.setState(setObj);
                                        }}
                                    />
                                    {errors.note ? <div className='error-feedback'>{errors.note}</div> : null}
                                </FormGroup>
                            </Col>

                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingCancelVisit}
                        >
                            {'Cancel visit'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Go back'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal >

                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}
            </>
        );
    }
}


export default VisitCancellation;
